import { Matrix23 } from '@seddi/math-v2';
export function create() {
    return { rotation: 0, translation: { x: 0, y: 0 } };
}
export function getTransformMatrix(self, ref) {
    ref.setRotation(self.rotation);
    ref.setTranslationFromFloats(self.translation.x, self.translation.y);
    return ref;
}
export const getInverseTransformMatrix = (() => {
    const m = new Matrix23();
    return (self, ref) => {
        getTransformMatrix(self, m);
        m.invertToRef(ref);
        return ref;
    };
})();
